<template>
  <dashboard-card class="db-particular" title="Particular" cut="Resumo do período"
                  note="Recebido direto do paciente, fora do convênio">
    <div class="db-kpis db-kpis-4">
      <router-link class="db-kpi db-kpi-green db-kpi-link" :to="todayRoute"
                   :class="{'is-zero': particular.today === 0}">
        <span class="db-kpi-label">Recebido hoje</span>
        <div class="db-kpi-value db-num">
          <span class="db-sk db-sk-lg" v-if="loading"></span>
          <template v-else>{{ particular.today | currency }}</template>
        </div>
        <span class="db-kpi-hint">{{ todayLabel }}</span>
      </router-link>

      <router-link class="db-kpi db-kpi-blue db-kpi-link" :to="monthRoute"
                   :class="{'is-zero': particular.month === 0}">
        <span class="db-kpi-label">Recebido no mês</span>
        <div class="db-kpi-value db-num">
          <span class="db-sk db-sk-lg" v-if="loading"></span>
          <template v-else>{{ particular.month | currency }}</template>
        </div>
        <span class="db-kpi-hint">{{ monthHint }}</span>
      </router-link>

      <router-link class="db-kpi db-kpi-red db-kpi-link" :to="overdueTo"
                   :class="{'is-zero': !hasOverdue}">
        <span class="db-kpi-label">Inadimplência</span>
        <div class="db-kpi-value db-num">
          <span class="db-sk db-sk-lg" v-if="loading"></span>
          <template v-else>{{ particular.overdue.value | currency }}</template>
        </div>
        <span class="db-kpi-alert" v-if="!loading && hasOverdue">{{ overdueHint }}</span>
        <span class="db-kpi-hint" v-else>nenhum título vencido no período</span>
      </router-link>

      <div class="db-kpi db-kpi-amber" :class="{'is-zero': particular.ticket === 0}">
        <span class="db-kpi-label">Ticket médio</span>
        <div class="db-kpi-value db-num">
          <span class="db-sk db-sk-lg" v-if="loading"></span>
          <template v-else>{{ particular.ticket | currency }}</template>
        </div>
        <span class="db-kpi-hint">por atendimento</span>
      </div>
    </div>
  </dashboard-card>
</template>

<script>
import moment from 'moment';
import { cashRoute, overdueRoute, pluralize } from '../helpers';
import DashboardCard from './DashboardCard.vue';

export default {
  components: {
    DashboardCard,
  },
  props: {
    particular: {
      type: Object,
      required: true,
    },
    filter: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    todayRoute() {
      return cashRoute(this.filter, 'today');
    },
    monthRoute() {
      return cashRoute(this.filter, 'month');
    },
    overdueTo() {
      return overdueRoute(this.filter);
    },
    hasOverdue() {
      return this.particular.overdue.value > 0 || this.particular.overdue.count > 0;
    },
    todayLabel() {
      return moment().format('DD/MM/YYYY');
    },
    monthHint() {
      const { count } = this.particular;
      if (count === 0) return moment().format('MMMM [de] YYYY');
      return pluralize(count, 'atendimento', 'atendimentos');
    },
    overdueHint() {
      const { count, patients } = this.particular.overdue;
      if (patients > 0) return `${pluralize(patients, 'paciente', 'pacientes')} em atraso`;
      return pluralize(count, 'título vencido', 'títulos vencidos');
    },
  },
};
</script>
